import React, { createRef, useCallback, useState } from "react";
import Popover from "./Popover";

export default function BookmarksPopover({ arrowX = "right" }) {
  const [isVisible, setIsVisible] = useState(true);
  const popoverRef = createRef();

  const dismiss = useCallback(() => {
    setIsVisible(false);
  }, [setIsVisible]);

  return (
    <Popover
      ref={popoverRef}
      arrowX={arrowX}
      containerClass="container dynamic"
      isVisible={isVisible}
      popoverClassName="bookmarks-popover"
    >
      <div className="content">
        <div className="image" />
        <div className="text">
          <div>
            <strong>Save Guides</strong>
            <span className="subcopy">New</span>
          </div>
          <div>Save any guide for easy access later!</div>
        </div>
      </div>
      <button
        className="btn btn-default btn-block btn-lg"
        onClick={dismiss}
        type="button"
      >
        Got It
      </button>
    </Popover>
  );
}
